import { Container } from "react-bootstrap";

import pdf from "../../Assets/Resume.pdf";
import Particle from "../Particle";

function Resume() {


  return (
    <Container fluid className="resume-section">
      <Particle/>
        <embed  src={pdf} width="810px" height="1185px" />
    </Container>
  );
}

export default Resume;
